import { render, staticRenderFns } from "./ElectionToggle.vue?vue&type=template&id=7d8c38bc"
import script from "./ElectionToggle.vue?vue&type=script&lang=js"
export * from "./ElectionToggle.vue?vue&type=script&lang=js"
import style0 from "./ElectionToggle.vue?vue&type=style&index=0&id=7d8c38bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports